import React from 'react';
import PropTypes from 'prop-types';
import { AutoSizer, List, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import { throttle } from 'lodash';

import theme from './Appointments.scss';

class AppointmentList extends React.Component {
  static propTypes = {
    AppointmentCard: PropTypes.func.isRequired,
    appointmentsById: PropTypes.arrayOf(PropTypes.string).isRequired,
    scrollToIndex: PropTypes.number.isRequired,
    scrollRestored: PropTypes.func.isRequired,
    appointmentSizeUpdated: PropTypes.func.isRequired,
    shouldUpdateListCache: PropTypes.bool.isRequired,
    fetchMoreAppointments: PropTypes.func.isRequired,
    canFetchMoreAppointments: PropTypes.bool.isRequired,
  };

  cache = new CellMeasurerCache({
    fixedWidth: true,
    minHeight: 100,
  });

  componentDidMount() {
    window.addEventListener('resize', this.recalculateRowsWithThrottle);
    setImmediate(this.props.scrollRestored);
  }

  componentDidUpdate() {
    if (this.props.shouldUpdateListCache) {
      setTimeout(() => {
        if (this.list) this.list.recomputeRowHeights();
        this.recalculateRows();
        this.props.appointmentSizeUpdated();
      });
    }
  }


  componentWillUnmount() {
    window.removeEventListener('resize', this.recalculateRowsWithThrottle);
  }

  recalculateRows = () => {
    this.cache.clearAll();
    this.list.forceUpdateGrid();
  };

  recalculateRowsWithThrottle = throttle(this.recalculateRows, 100);

  onScroll = ({ clientHeight, scrollHeight, scrollTop }) => {
    const { fetchMoreAppointments, canFetchMoreAppointments } = this.props;

    if (!canFetchMoreAppointments || scrollTop === 0) return;

    if ((scrollTop + clientHeight) > (scrollHeight - 500)) {
      fetchMoreAppointments();
    }
  };

  rowRenderer = ({ index, key, style, parent }) => {
    const AppointmentCard = this.props.AppointmentCard;
    const appointmentId = this.props.appointmentsById[index];
    return (
      <CellMeasurer
        key={ key }
        cache={ this.cache }
        parent={ parent }
        columnIndex={ 0 }
        rowIndex={ index }
      >
        <AppointmentCard appointmentId={ appointmentId } style={{ ...style, top: index === 0 ? style.top : style.top + 5 }} />
      </CellMeasurer>
    );
  };

  render() {
    const { appointmentsById, scrollToIndex } = this.props;

    return (
      <div className={ theme.root }>
        <AutoSizer>
          { ({ width, height }) => (
            <List
              tabIndex={ -1 }
              onScroll={ this.onScroll }
              ref={ (ref) => this.list = ref } // eslint-disable-line
              className={ theme.list }
              width={ width }
              height={ height }
              rowCount={ appointmentsById.length }
              rowRenderer={ this.rowRenderer }
              deferredMeasurementHeight={ this.cache }
              rowHeight={ this.cache.rowHeight }
              overscanRowCount={ 0 }
              scrollToAlignment="center"
              scrollToIndex={ scrollToIndex }
              role="Tabpanel"
            />
          ) }
        </AutoSizer>
      </div>
    );
  }
}

export default AppointmentList;
